import store from '@/store/index';
import { revertEgress } from '../../../_api.js';

export const REVERT_EGRESS_SHOW_ITEM = 'REVERT_EGRESS';

export default {
  data: () => ({
    revertEgressReason: '',
  }),
  computed: {
    showingRevertEgress() {
      return this.showing === REVERT_EGRESS_SHOW_ITEM;
    },
    canRevertEgress() {
      return (
        this.isNoValidityEgress &&
        store.getters.HasPermission(
          'academic.pei.ubicationtechassistance.request.revertegress'
        )
      );
    },
  },
  methods: {
    openRevertEgressPanel() {
      this.revertEgressReason = '';
      this.isChangeToCentralLevelStatusOpened = false;
      this.showing = REVERT_EGRESS_SHOW_ITEM;
    },
    cancelRevertEgress() {
      this.revertEgressReason = '';
      this.showing = null;

      const form = this.$refs && this.$refs.revertEgressForm;
      if (form && form.reset) form.reset();
    },
    async saveRevertEgress() {
      const valid = await this.$refs.revertEgressForm.validate();
      if (!valid) return;

      try {
        await revertEgress(this.item.id, {
          reason: this.revertEgressReason.trim(),
        });

        this.ShowToast(
          '',
          'Cambio de estatus realizado exitosamente.',
          'success'
        );
        this.cancelRevertEgress();
        this.$emit('status-has-changed');
      } catch (error) {
        const errorMessage =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;

        this.ShowToast(
          'Alerta',
          errorMessage || 'Ha ocurrido un error inesperado.',
          'error'
        );
      }
    },
  },
};
